var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticClass:"mt-4 mb-5"}),_c('div',{staticClass:"form-group mb-4"},[_c('CreatePromoCodeForm',{attrs:{"type":"in-store","placeholder":"TWO4ONE"}})],1),_c('hr',{staticClass:"mt-4 mb-5"}),_c('div',{staticClass:"form-group mb-4"},[_c('CreatePromoCodeForm',{attrs:{"type":"off-premise","placeholder":"BOGO324"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }